// extracted by mini-css-extract-plugin
module.exports = {"entitiesSettings":"_1IWQa","addEntitiesButton":"YXE+J","newEntityFormItem":"cGVpJ","addEntitiesPopover":"A82FP","openedNewEntityButton":"xL370","newEntityInput":"UIctQ"};